import React, { Component } from "react";
import { Form, FormGroup, FormControl, ControlLabel, Glyphicon, Tooltip, OverlayTrigger, Col, Panel, Alert } from "react-bootstrap";
import axios from 'axios';
import LoaderButton from "../../components/LoaderButton";
import config from '../../config';

export default class Contact extends Component {
  constructor(props) {
  	super(props);
  	this.state = {
  	  isLoading: false,
      condominium: '',
  	  name: '',
  	  phone: '',
  	  email: '',
      message: '',
      alertMessage: '',
      isErrorMessage: false
  	};
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  validate() {
    var errors = [];
    if (this.state.condominium.length < 3) {
      errors.push('Debe ingresar un condominio válido');
    }
    if (this.state.name.length < 3) {
      errors.push('Debe ingresar un nombre válido');
    }
    if (this.state.email.length < 8) {
      errors.push('Debe ingresar un email válido');
    }
    if (this.state.phone.length < 8) {
      errors.push('Debe ingresar un teléfono válido');
    }
    if (this.state.message.length < 3) {
      errors.push('Debe ingresar el mensaje');
    }
    return errors;
  }
  handleSubmit = async event => {
    event.preventDefault();
    const errors = this.validate();
    if (errors.length) {
      this.setState({ alertMessage: errors.join('<br>'), isErrorMessage: true });
      return;
    }
    this.setState({ isLoading: true });
    try {
  	  const response = await this.contactSupport({
        ...this.props.fields,
        condominium: this.state.condominium,
  	    name: this.state.name,
        email: this.state.email,
        phone: this.state.phone,
        message: this.state.message
      });
      console.log(response);
      this.setState({ isLoading: false, alertMessage: 'Hemos recibido tu mensaje, pronto nos comunicaremos contigo.', isErrorMessage: false, condominium: '', name: '', email: '', phone: '', message: '' });
    } catch (e) {
      console.error(e);
      this.setState({ isLoading: false, alertMessage: 'Error al enviar mensaje. Favor intenta nuevamente', isErrorMessage: true });
    }
  }
  contactSupport(support) {
    return axios.post(config.AWS.API + '/contact', support)
      .then(res => {
          console.log(res);
      });
  }
  render() {
    return (
      <Panel>
        <Panel.Heading>
          Cont&aacute;ctanos
        </Panel.Heading>
        <Panel.Body>
          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup controlId="condominium">
              <Col componentClass={ControlLabel} sm={2}>
                Condominio{' '}
              </Col>
              <Col sm={9}>
                <FormControl componentClass="input" onChange={this.handleChange} value={this.state.condominium} placeholder="Nombre o dirección del condominio" />
              </Col>
              <Col sm={1}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese el nombre o dirección del condominio.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            <FormGroup controlId="name">
              <Col componentClass={ControlLabel} sm={2}>
                Nombre
              </Col>
              <Col sm={9}>
                <FormControl componentClass="input" onChange={this.handleChange} value={this.state.name} placeholder="Nombre completo" />
              </Col>
              <Col sm={1}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su nombre.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={2}>
                Email
              </Col>
              <Col sm={9}>
                <FormControl componentClass="input" onChange={this.handleChange} value={this.state.email} placeholder="email@dominio.com" />
              </Col>
              <Col sm={1}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su e-mail.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            <FormGroup controlId="phone">
              <Col componentClass={ControlLabel} sm={2}>
                Teléfono
              </Col>
              <Col sm={9}>
                <FormControl componentClass="input" onChange={this.handleChange} value={this.state.phone} placeholder="Teléfono celular o fijo" />
              </Col>
              <Col sm={1}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su teléfono.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            <FormGroup controlId="message">
              <Col componentClass={ControlLabel} sm={2}>
                Mensaje
              </Col>
              <Col sm={9}>
                <FormControl
                  componentClass="textarea"
                  onChange={this.handleChange}
                  value={this.state.message}
                  placeholder="Escriba su mensaje..."
                />
              </Col>
              <Col sm={1}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su mensaje lo más claro posible.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            { this.state.alertMessage && this.state.isErrorMessage  && <Alert bsStyle="danger" ><div dangerouslySetInnerHTML={{__html: this.state.alertMessage}}/></Alert> }
            { this.state.alertMessage && !this.state.isErrorMessage  && <Alert bsStyle="success" ><div dangerouslySetInnerHTML={{__html: this.state.alertMessage}}/></Alert> }
            <LoaderButton
                  block
                  bsStyle="primary"
                  bsSize="large"
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Enviar"
                  loadingText="Enviando…" />
          </Form>
        </Panel.Body>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/contact/ContactForm.js